module.exports = __webpack_public_path__ + "static/Advantage01@3x.311e3b25.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/events/new/Advantage01@3x.png
// module id = 685
// module chunks = 216210090109534